import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UrlValidatorService } from '../services/url-validator.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router,
    private urlValidator: UrlValidatorService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkAuth(state.url);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }

  private checkAuth(url: string): Observable<boolean | UrlTree> {
    return this.authService.checkAuthStatus().pipe(
      take(1),
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true;
        }

        // Validasi URL sebelum menyimpannya sebagai returnUrl
        const validatedUrl = this.urlValidator.validateReturnUrl(url);
        
        // Log jika URL dimodifikasi karena tidak valid
        if (url !== validatedUrl) {
          console.warn('Auth Guard: Invalid URL sanitized', {
            original: url,
            sanitized: validatedUrl
          });
        }

        // Hanya simpan returnUrl jika bukan default route
        const queryParams: any = {};
        if (validatedUrl !== '/dashboard' && validatedUrl !== '/') {
          queryParams.returnUrl = validatedUrl;
        }

        // Redirect to the login page dengan validated URL
        return this.router.createUrlTree(['/login'], { queryParams });
      })
    );
  }
}